/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const tags = (state) => {
  return state.tags
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getTagById = (state) => (id) => {
  return state.tags.find(tag => tag.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  tags,
  total,
  offset,
  max,
  getTagById,
  sort,
  order
}
